<script setup lang="ts">
import type { IProps } from './UiBoxThreeOnRow.types'
import UiBox from './UiBox/UiBox.vue'
defineProps<IProps>()

</script>

<template>
  <div class="ui-box-three-on-row">
    <h6 class="ui-box-three-on-row__title">
      {{ title }}
    </h6>

    <div class="ui-box-three-on-row__flexbox">
      <UiBox
        v-for="(box, index) in boxes"
        :key="index"
        v-bind="box"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-box-three-on-row {
  margin-right: -25px;
  margin-left: -25px;
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: $gray-100;

  &__title {
    @include h8;
    padding-bottom: 3.2rem;
    color: $text-400;
    text-align: center;
  }

  &__flexbox {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    padding: 0 2.5rem;
  }

  @include atS {
    margin-right: -45px;
    margin-left: -45px;
    padding-top: 14rem;
    padding-bottom: 14rem;

    &__flexbox {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 1.9rem;
      max-width: 100rem;
      margin: auto;
      padding: 0;
    }

    &__title {
      @include h4;
      padding-bottom: 7.2rem;
    }
  }

  @include atM {
    margin-right: auto;
    margin-left: auto;
    
    &__flexbox {
      max-width: 136rem;
    }
  }
}
</style>
